import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AppShell } from "./shell/AppShell";
import { Home } from "./pages/Home";
import { RunOverview, RunView } from "./pages/RunView";
import { ArtifactView } from "./pages/ArtifactView";
import { GateView } from "./pages/GateView";
import { LibraryPage } from "./pages/LibraryPage";
import { NewIdea } from "./pages/NewIdea";
import { SettingsPage } from "./pages/SettingsPage";
import { VocabProvider } from "./vocab";
import "./styles.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 5_000, refetchOnWindowFocus: true },
  },
});

const router = createBrowserRouter([
  {
    element: <AppShell />,
    children: [
      { path: "/", element: <Home /> },
      { path: "/new", element: <NewIdea /> },
      { path: "/library", element: <LibraryPage /> },
      { path: "/settings", element: <SettingsPage /> },
      {
        path: "/runs/:runId",
        element: <RunView />,
        children: [
          { index: true, element: <RunOverview /> },
          { path: "a/*", element: <ArtifactView /> },
          { path: "gate/:gate", element: <GateView /> },
        ],
      },
    ],
  },
]);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      {/* VocabProvider reads the per-user mode from the auth query, so it
          must sit inside the QueryClientProvider. */}
      <VocabProvider>
        <RouterProvider router={router} />
      </VocabProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
